import { TheNightlySection } from '@news-mono/common'
import { sectionThemeOverrider, metrics } from '@news-mono/component-library'
import {
    GetRouteAdTargeting,
    LoadedElectionDefinition,
    PageType,
} from '@news-mono/web-common'
import { layout } from '../../../App.routing'

type CreateElectorateEmbedPageArgs = {
    electionDefinition: LoadedElectionDefinition
    getAdTargeting: GetRouteAdTargeting
}

export const createElectorateEmbedPage = ({
    electionDefinition,
    getAdTargeting,
}: CreateElectorateEmbedPageArgs): PageType<TheNightlySection> => {
    return {
        kind: 'page',
        heading: 'Election Embed page',
        pageType: 'static',
        section: 'politics',
        hideHeading: true,
        adTargeting: getAdTargeting('home', 'default', 'home'),
        compositions: [
            layout.composition({
                type: 'scheme-overrider',
                props: {
                    override: sectionThemeOverrider('thenightly', 'politics'),
                },
                contentAreas: {
                    children: [
                        layout.nestedComposition({
                            type: 'box',
                            props: {
                                containerWidth:
                                    metrics.thenightly.siteMetrics
                                        .mainContentWidth,
                                fullWidth: true,
                            },
                            contentAreas: {
                                main: [
                                    layout.component({
                                        type: 'election-seat-embed-widget',
                                        props: {
                                            electionDefinition,
                                        },
                                    }),
                                ],
                            },
                        }),
                    ],
                },
            }),
        ],
    }
}
